module.exports = (parcelRequire.load("97G3e")).then(() => parcelRequire('jB8x3'));